module.exports = __webpack_public_path__ + "static/media/iar_vehicle_other_hover.c9a9f6c5.svg";